import React from 'react';
import { StepIndicator } from './StepIndicator';
import { ThemeToggle } from '@/components/ui/theme-toggle';
import { cn } from '@/lib/utils';

interface OnboardingSidebarProps {
  steps: string[];
  className?: string;
}

export const OnboardingSidebar: React.FC<OnboardingSidebarProps> = ({ steps, className }) => {
  return (
    <aside
      className={cn(
        'hidden md:flex md:flex-col md:w-[220px] md:min-h-screen',
        'bg-surface-0 border-r border-border',
        'noise-grain shrink-0',
        className,
      )}
    >
      {/* Logo / Wordmark */}
      <div className="px-5 pt-6 pb-4">
        <p className="font-heading text-lg font-bold uppercase tracking-[0.08em] text-foreground" role="img" aria-label="AVPro BMS">
          AVPro BMS
        </p>
        <p className="text-[11px] font-label uppercase tracking-[0.05em] text-muted-foreground mt-0.5">
          Account Setup
        </p>
      </div>

      {/* Divider */}
      <div className="mx-4 border-t border-border mb-2" />

      {/* Step list */}
      <StepIndicator steps={steps} variant="sidebar" />

      {/* Spacer + theme toggle pinned to bottom */}
      <div className="mt-auto px-5 pb-5">
        <div className="border-t border-border pt-3">
          <ThemeToggle />
        </div>
      </div>
    </aside>
  );
};
